import {
    Box,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Chip,
    Divider,
    Paper
} from '@mui/material';
import { useState } from 'react';
import AnnouncementItemDialog from '../Dialog/AnnouncementItemDialog';
import { getLocaleDateTime, getLocaleDateWithTimeCustom, getLocaleDateWithTimeCustomV2, getShortLocaleDateTime } from 'app/utils/appHelpers';

function AnnouncementItem({ announcement }) {
    const [openDialog, setOpenDialog] = useState(false);

    const handleClick = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    // Duyuru tarihinin 2 gün öncesine kadar olup olmadığını kontrol et
    const isNew = () => {
        const announcementDate = new Date(announcement.addedDate);
        const twoDaysAgo = new Date();
        twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
        return announcementDate >= twoDaysAgo;
    };

    // Title'ı 100 karakterle sınırla
    const truncateTitle = (title) => {
        return title.length > 100 ? title.substring(0, 100) + '...' : title;
    };

    return (
        <>
            {/* Table Row Style */}
            <Paper
                onClick={handleClick}
                elevation={0}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    p: 2,
                    mb: 1,
                    mr: 0.3,
                    ml: 0.3,

                    border: '1px solid',
                    borderColor: 'rgba(25, 118, 210, 0.1)',
                    borderRadius: 2,
                    cursor: 'pointer',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8faff 50%, #ffffff 100%)',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '2px',
                        background: 'linear-gradient(90deg, #1976d2, #42a5f5, #1976d2)',
                        transform: 'scaleX(0)',
                        transition: 'transform 0.4s ease',
                        transformOrigin: 'left'
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(25, 118, 210, 0.05)',
                        borderColor: 'primary.main',
                        transform: 'translateY(-2px) scale(1.01)',
                        boxShadow: '0 6px 20px rgba(25, 118, 210, 0.15)',
                        '&::before': {
                            transform: 'scaleX(1)'
                        },
                        '& .announcement-title': {
                            color: 'primary.main',
                            fontWeight: 'bold',
                            transform: 'translateX(3px)'
                        },
                        '& .announcement-date': {
                            color: 'primary.dark',
                            transform: 'translateX(3px)'
                        },
                        '& .arrow-icon': {
                            opacity: 1,
                            transform: 'translateX(3px)',
                            color: 'primary.main'
                        }
                    },
                    '&:active': {
                        transform: 'translateY(-1px) scale(1.005)',
                        boxShadow: '0 3px 12px rgba(25, 118, 210, 0.2)'
                    }
                }}
            >
                {/* Sol taraf - Chip'ler, Başlık ve Tarih */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    gap: 0.3,
                    transition: 'all 0.3s ease'
                }}>
                    {/* Üst satır - Chip'ler */}
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }}>

                        {/* Yeni Badge */}
                        {isNew() && (
                            <Box
                                sx={{
                                    animation: 'pulse 2s infinite',
                                    '@keyframes pulse': {
                                        '0%': {
                                            transform: 'scale(1)',
                                            opacity: 1
                                        },
                                        '50%': {
                                            transform: 'scale(1.1)',
                                            opacity: 0.8
                                        },
                                        '100%': {
                                            transform: 'scale(1)',
                                            opacity: 1
                                        }
                                    }
                                }}
                            >
                                <Chip
                                    label="YENİ"
                                    size="small"
                                    sx={{
                                        fontSize: '8px',
                                        height: '14px',
                                        backgroundColor: '#ff4444',
                                        color: 'white',
                                        fontWeight: 'normal',
                                        '& .MuiChip-label': {
                                            padding: '0 5px'
                                        }
                                    }}
                                />
                            </Box>
                        )}
                        {/* From Announcement */}
                        <Chip
                            label={announcement.fromAnnouncement || 'Kurum'}
                            size="small"
                            sx={{
                                fontSize: '9px',
                                height: '14px',
                                backgroundColor: 'rgba(25, 118, 210, 0.1)',
                                color: 'primary.main',
                                fontWeight: 'normal',
                                '& .MuiChip-label': {
                                    padding: '0 5px'
                                }
                            }}
                        />


                    </Box>

                    {/* Alt satır - Title */}
                    <Typography
                        variant="body2"
                        className="announcement-title"
                        sx={{
                            fontSize: '11px',
                            fontWeight: 'normal',
                            color: '#2c3e50',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            lineHeight: 1.3,
                            transition: 'all 0.3s ease',
                            textShadow: '0 1px 1px rgba(0,0,0,0.03)'
                        }}
                    >
                        {truncateTitle(announcement.title)}
                    </Typography>

                    {/* En alt satır - Tarih */}
                    <Typography
                        variant="caption"
                        className="announcement-date"
                        sx={{
                            fontSize: '9px',
                            color: '#6c757d',
                            fontWeight: 'normal',
                            fontFamily: 'monospace',
                            transition: 'all 0.3s ease',
                            letterSpacing: '0.3px'
                        }}
                    >
                        {getLocaleDateWithTimeCustomV2("tr", announcement.updatedDate)}
                    </Typography>
                </Box>

                {/* Sağ taraf - Ok işareti */}
                <Box sx={{
                    ml: 1.5,
                    opacity: 0.4,
                    transition: 'all 0.3s ease',
                    transform: 'translateX(0px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(25, 118, 210, 0.1)'
                }}>
                    <Typography
                        variant="caption"
                        className="arrow-icon"
                        sx={{
                            color: '#6c757d',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        ›
                    </Typography>
                </Box>
            </Paper>

            {
                openDialog && (
                    <AnnouncementItemDialog open={openDialog} onClose={handleCloseDialog} announcement={announcement} />
                )
            }
        </>
    );
}

export default AnnouncementItem;